/**
 * ============================================================
 * Fur-Real — Hero & Scroll Animation Hook
 * FILE: assets/fur-real-animations.js
 * LOAD IN: layout/theme.liquid (before </body>, defer)
 *
 * PURPOSE:
 *   Demonstrates the correct pattern for connecting any animation
 *   system to the splash screen completion event.
 *   Replace the stub functions with your real animation code.
 * ============================================================
 */

(function FurRealAnimations() {
  'use strict';

  /**
   * Called once — after splash transition fully completes.
   * This is the ONLY safe place to begin hero animations
   * and initialize scroll-based effects.
   */
  function onSplashComplete() {
    initHeroAnimation();
    initScrollAnimations();
  }

  /* ── HERO ANIMATION ─────────────────────────────────────────── */
  function initHeroAnimation() {
    /**
     * Replace this stub with your hero animation logic.
     *
     * Example with GSAP:
     *
     * gsap.fromTo('.hero-headline',
     *   { opacity: 0, y: 30 },
     *   { opacity: 1, y: 0, duration: 1, ease: 'power3.out' }
     * );
     *
     * Example for video autoplay:
     *
     * const heroVideo = document.querySelector('.hero-video');
     * if (heroVideo) heroVideo.play();
     *
     * Example for Lottie / canvas animation:
     *
     * if (window.heroAnimation) window.heroAnimation.play();
     */
    console.log('[Fur-Real] Hero animation initialized');
  }

  /* ── SCROLL ANIMATIONS ──────────────────────────────────────── */
  function initScrollAnimations() {
    /**
     * Replace with your scroll animation initialization.
     *
     * Example with GSAP ScrollTrigger:
     *
     * if (!window.ScrollTrigger) return;
     * ScrollTrigger.refresh();
     *
     * gsap.utils.toArray('[data-scroll-reveal]').forEach(el => {
     *   gsap.fromTo(el,
     *     { opacity: 0, y: 40 },
     *     {
     *       opacity: 1, y: 0,
     *       duration: 0.8,
     *       ease: 'power2.out',
     *       scrollTrigger: {
     *         trigger: el,
     *         start: 'top 85%',
     *       }
     *     }
     *   );
     * });
     *
     * Example with AOS:
     *
     * if (window.AOS) AOS.init({ once: true });
     */
    console.log('[Fur-Real] Scroll animations initialized');
  }

  /* ── EVENT WIRING ───────────────────────────────────────────── */
  /**
   * Handle both cases:
   *   a) Script loads BEFORE splash completes → listen for event
   *   b) Script loads AFTER splash completes → flag already set
   */
  if (window.__furRealSplashDone) {
    // Splash already done by the time this script ran
    onSplashComplete();
  } else {
    document.addEventListener('furreal:splashComplete', onSplashComplete, { once: true });
  }

}());